export default "__VITE_ASSET__BclGGHfW__"